// extracted by mini-css-extract-plugin
export default {"editBadge":"EditBadge_editBadge__E2UFh"};